"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Trail = void 0;
var styled_1 = __importDefault(require("@emotion/styled"));
var React = __importStar(require("react"));
var icons_1 = require("../icons");
var theme_1 = require("../theme");
var List = styled_1.default.ol(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  color: ", ";\n  font-size: ", ";\n"], ["\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  display: flex;\n  flex-wrap: wrap;\n  flex-shrink: 0;\n  color: ", ";\n  font-size: ", ";\n"])), theme_1.theme.colors.n400, theme_1.theme.fontSizes.fontsize16);
var ListItem = styled_1.default.li(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  line-height: ", ";\n  margin-bottom: ", ";\n"], ["\n  display: flex;\n  line-height: ", ";\n  margin-bottom: ", ";\n"])), theme_1.theme.space.space24, theme_1.theme.space.space8);
var CrumbWrapper = styled_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  display: flex;\n  align-items: flex-end;\n"], ["\n  display: flex;\n  align-items: flex-end;\n"])));
var Separator = styled_1.default.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  display: flex;\n  padding-bottom: ", ";\n  margin: 0 ", ";\n"], ["\n  display: flex;\n  padding-bottom: ", ";\n  margin: 0 ", ";\n"])), theme_1.theme.space.space4, theme_1.theme.space.space8);
var Trail = function (_a) {
    var children = _a.children, className = _a.className;
    return (React.createElement(List, { className: className }, React.Children.map(children, function (child, index) {
        var isLastItem = index == React.Children.count(children) - 1;
        return (React.createElement(ListItem, { key: index },
            React.createElement(CrumbWrapper, null,
                child,
                !isLastItem && (React.createElement(Separator, { key: "separator-".concat(index) },
                    React.createElement(icons_1.ArrowRightIcon, { size: theme_1.theme.space.space16 }))))));
    })));
};
exports.Trail = Trail;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;
//# sourceMappingURL=Trail.js.map